export default __webpack_public_path__ + "static/poster-solution-29c8c757ad63ddb86335cd0681c99694.jpg";